import { useCoverage } from '@/stores/coverage/coverage.ts'

// Retrieves store if it's populated.
// If this the first time accessing the store (store is empty),
// then it makes the API call and updates/returns the store
export async function retrieveCoverage() {
	const store = useCoverage()

	if (!store.loaded) {
		await store.loadCoverageStore()
	}

	return store
}
